export function getCookie(cookieName: string): boolean {
  const cookieNameRegex = new RegExp(cookieName, 'ig');

  return cookieNameRegex.test(window.document.cookie);
}
